import Vue from 'vue';
import Vuex, { Store } from 'vuex';

// The Vuex modules.
import cart from './modules/cart';
import purchase from './modules/purchase';

// Add the Vuex plugin.
Vue.use(Vuex);

export default new Store({
  modules: {
    cart,
    purchase,
  },
});
